import { AssetProgressDto } from "@core/typesV2";
import { ActivityProgressService } from "@servicesV2";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useService } from "./useService";

export type SubmitAssetMutationParams = {
  courseId: string;
  activityId: string;
  assetId: string;
};

export function useSubmitAssetMutation() {
  const { initialization: activityProgressServiceInit } = useService(
    ActivityProgressService,
  );

  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["grade-asset"],

    mutationFn: async ({
      courseId,
      activityId,
      assetId,
    }: SubmitAssetMutationParams) => {
      const { service: activityProgressService } =
        await activityProgressServiceInit;

      return activityProgressService.submitAsset(courseId, activityId, assetId);
    },

    onSuccess: (data, { courseId, activityId, assetId }) => {
      const progressKey = [
        "assets",
        "progress",
        { courseId, activityId, learnerId: null },
      ] as const;

      queryClient.setQueryData<AssetProgressDto[]>(progressKey, (old = []) => {
        const idx = old.findIndex((p) => p.assetId === assetId);

        const patch: Partial<AssetProgressDto> = {
          feedback: data ?? null,
        };

        if (idx === -1) {
          return [...old, { id: assetId, ...(patch as AssetProgressDto) }];
        }

        const next = old.slice();
        next[idx] = { ...next[idx], ...patch } as AssetProgressDto;
        return next;
      });
    },
  });
}
